export enum SiteReccePriorityEnum {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
}

export enum SiteRecceTypeEnum {
    INITIAL_SITE_SURVEY = 'INITIAL_SITE_SURVEY',
    INSTALLATION = 'INSTALLATION',
    MAINTENANCE = 'MAINTENANCE',
    REMOVAL = 'REMOVAL',
}

export enum AssetTypeEnum {
    TIMELAPSE_CAMERA = 'TIMELAPSE_CAMERA',
    LIVE_CAMERA = 'LIVE_CAMERA',
    CAMERA_360 = 'CAMERA_360',
}

// Mappings for human-readable labels

export const SiteReccePriorityLabels = {
    [SiteReccePriorityEnum.LOW]: 'Low',
    [SiteReccePriorityEnum.HIGH]: 'High',
    [SiteReccePriorityEnum.MEDIUM]: 'Medium',
};

export const SiteRecceTypeLabels = {
    [SiteRecceTypeEnum.INITIAL_SITE_SURVEY]: 'Initial Site Survey',
    [SiteRecceTypeEnum.INSTALLATION]: 'Installation',
    [SiteRecceTypeEnum.MAINTENANCE]: 'Maintenance',
    [SiteRecceTypeEnum.REMOVAL]: 'Removal',
};

export const AssetTypeLabels = {
    [AssetTypeEnum.TIMELAPSE_CAMERA]: 'Timelapse Camera',
    [AssetTypeEnum.LIVE_CAMERA]: 'Live Camera',
    [AssetTypeEnum.CAMERA_360]: '360 Camera',
};

export enum SiteRecceStatusEnum {
    UNASSIGNED = 'UNASSIGNED',
    ASSIGNED = 'ASSIGNED',
    COMPLETED = 'COMPLETED',
    REJECTED = 'REJECTED',
}

export const SiteRecceStatusLabels: Record<SiteRecceStatusEnum, string> = {
    [SiteRecceStatusEnum.UNASSIGNED]: 'Unassigned',
    [SiteRecceStatusEnum.ASSIGNED]: 'Assigned',
    [SiteRecceStatusEnum.COMPLETED]: 'Completed',
    [SiteRecceStatusEnum.REJECTED]: 'Rejected',
};
